import { render, staticRenderFns } from "./TagExperienceStatus.vue?vue&type=template&id=e56703b4&scoped=true&"
import script from "./TagExperienceStatus.vue?vue&type=script&lang=js&"
export * from "./TagExperienceStatus.vue?vue&type=script&lang=js&"
import style0 from "./TagExperienceStatus.vue?vue&type=style&index=0&id=e56703b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56703b4",
  null
  
)

export default component.exports